import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { VacancyApplicationStatuses } from '@/constants/vacancies/vacancyApplicationStatuses'
import { RootState } from '@/store'

export default Vue.extend({
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
      roomId: (state: RootState) => state.chatNew.openedRoomId,
    }),
    ...mapGetters({
      room: 'chatNew/getOpenedRoom',
    }),
    isDone() {
      return [VacancyApplicationStatuses.ARCHIVED, VacancyApplicationStatuses.APPLIED].includes(this.application?.status)
    },
    isTemporary() {
      return this.room?.temporary || (this.roomId || '').startsWith('tmp_')
    },
  },
})
